import axios from "axios";

export const roleService = {
  getAllRole
};

function getAllRole() {
  const domain = window.location.hostname;
  const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
  return axios.get(`${process.env.VUE_APP_API_URL}/role/all?product=${product}`);
}
